// extracted by mini-css-extract-plugin
export var phone = "_18-0";
export var phoneDragging = "_18-1";